module.exports = __webpack_public_path__ + "static/media/first_christian_church2.bf477dd8.png";